/** @format */

// 销售状态
export enum SaleStatus {
  Saling = '01',
  StopSale = '00'
}

export const SaleStatusMap: {
  [key: string]: string;
} = {
  [SaleStatus.Saling]: '在售',
  [SaleStatus.StopSale]: '已停售'
};

//套餐优惠类型 01 时长 02金额
export enum CouponType {
  Time = '01',
  Price = '02'
}

export const couponTypeMap: {
  [key: string]: string;
} = {
  [CouponType.Price]: '金额',
  [CouponType.Time]: '时长'
};
